interface SkillGroup {
    group: string;
    items: string[];
}

const stack: SkillGroup[] = [
    {
        group: "Programmiersprachen",
        items: ["Go", "Python", "Java", "JavaScript", "TypeScript", "Bash", "PHP", "C#"],
    },
    {
        group: "Cloud & Container",
        items: ["Kubernetes", "Docker", "Helm", "Talos Linux", "Hetzner Cloud"],
    },
    {
        group: "Infrastructure as Code",
        items: ["Terraform", "OpenTofu", "Ansible", "GitOps", "ArgoCD"],
    },
    {
        group: "Frameworks",
        items: ["React", "Node.js", "Angular", "Gin"],
    },
    {
        group: "Datenbanken",
        items: ["PostgreSQL", "MariaDB", "MongoDB", "Redis"],
    },
    {
        group: "Monitoring & Security",
        items: ["Prometheus / Grafana", "HashiCorp Vault", "GPG"],
    },
    {
        group: "Versionsmanagement",
        items: ["Git", "GitLab", "GitHub", "CI/CD"],
    },
    {
        group: "Betriebssysteme",
        items: ["Linux", "Proxmox", "Windows", "WSL"],
    },
];

export default function Stack() {
    return (
        <section id="stack" className="card">
            <h2 className="card__title">Skills &amp; Tech Stack</h2>
            <div className="stack">
                {stack.map((group) => (
                    <div key={group.group} className="stack__group">
                        <h3 className="stack__group-title">{group.group}</h3>
                        <ul className="stack__chips">
                            {group.items.map((item) => (
                                <li key={item} className="stack__chip">
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </section>
    );
}
